// extracted by mini-css-extract-plugin
export default {"root":"wClohRw7","column":"CJIgEaon","value":"tNXlkgCq","label":"FPo_82Qq","valueChange":"OJgjeVxc","pill":"zKyEXMib","pillPositive":"jdvfgkko","pillNegative":"rw8LFnzA"};